import { render, staticRenderFns } from "./MobileNavigationItem.vue?vue&type=template&id=309e53e5"
import script from "./MobileNavigationItem.vue?vue&type=script&lang=ts"
export * from "./MobileNavigationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports